<template>
  <div>
    <!-- 编辑选校 -->
    <el-dialog :visible.sync="openDialog" width="50%" title="记录" center>
      <div class="block">
        <div class="block">
          <el-timeline>
            <el-timeline-item v-for="(item) in lists" :timestamp="item.created_at" placement="top">
              <el-card>
<!--                <p>操作人：{{item.operator_name}}</p>-->
                <!-- <p>角色：{{item.identity}}</p> -->
                <!-- <p>状态：
                  <span v-if="item.status==0">待学生确认</span>
                  <span v-if="item.status==1">已确认</span>
                  <span v-if="item.status==2">待修改</span>
                </p> -->
                <!-- <p>文件名：{{item.name}}</p> -->
                <p>
                  文件：
                  <el-link :underline="false" type="primary" @click="()=>{previewUrl=item.url;previewName=item.name}" >
                  <span>{{item.name}}</span>
                    <!--                    下载-->
<!--                    <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>-->
                  </el-link>
                  <span v-if="item.document_status==1" style="color: red">[终稿]</span>
                  <span v-if="item.document_status==2" style="color: red">【草稿】</span>
                </p>
                <p v-if="item.con">
                  反馈:单词翻译错误，已在文档中备注；附件下载
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>
  </div>
</template>

<script>
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';

export default {
  components: {
    HBFilePreview
  },
  data() {
    return {
      previewUrl:null,
      previewName:null,
      reverse: true,
      openDialog: false,
      lists: ''
    }
  },
  created() {

  },
  methods: {
    sendItem(_content) {
      console.log(_content)
      this.lists = _content
      this.openDialog = true
    },
    exportFile(data, fileName, _this){ // url name
      // 地址不存在时，禁止操作
      if(!data)return;
      // 下载文件并保存到本地
      const callback = (data)=>{
        // 创建a标签，使用 html5 download 属性下载，
        const link = document.createElement('a');
        // 创建url对象
        const objectUrl = window.URL.createObjectURL(new Blob([data]));
        link.style.display='none';
        link.href=objectUrl;
        // 自定义文件名称， fileName
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        // 适当释放url
        window.URL.revokeObjectURL(objectUrl);
      };
      // 把接口返回的url地址转换为 blob
      const xhr = new XMLHttpRequest();
      xhr.open('get', data, true);
      xhr.responseType = 'blob';
      xhr.onload = ()=> {
        // 返回文件流，进行下载处理
        callback(xhr.response);
      };
      xhr.send(); // 不要忘记发送
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/show_document.vue